export default __webpack_public_path__ + "locales/bg/DataReassignmentDialog.json?hash=4df18baa7fb1984c7e2f035e233f6d48";